/** @format */
import styled, { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    margin-bottom: var(--layout-spacing-32);

    .included-accessory__title {
        display: flex;
        gap: var(--layout-spacing-8);
        align-items: center;
        ${theme.typography.body_large}
        color: var(--colors-text-secondary);
        margin-bottom: var(--layout-spacing-8);
    }

    .included-accessory__icon svg {
        fill: var(--colors-surface-accent-inverse);
    }

    .included-accessory__icon--hidden {
        display: none;
    }

    .included-accessory__description {
        ${theme.typography.body_small}
        margin-bottom: var(--layout-spacing-16);

        strong {
            color: var(--colors-text-secondary);
        }
    }

    .included-accessory__options {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--layout-spacing-8);
        margin-bottom: var(--layout-spacing-8);
    }

    .included-accessory__group-name {
        ${theme.typography.body_small}
        letter-spacing: var(--typography-letter-spacing-tighter);
        font-weight: var(--typography-weight-bold);
        color: var(--colors-text-secondary);
        row-gap: var(--layout-spacing-10);

        &.included-accessory__group-name--full-width {
            flex: 1 0 100%;
        }
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledTooltip = styled('div')`
    p {
        margin-bottom: var(--layout-spacing-8);
    }
`;
